import { createRouter, createWebHistory } from 'vue-router';
import { getAuth } from 'firebase/auth';
import HelloWorld from './components/HelloWorld.vue';
import AdminLogin from './components/AdminLogin.vue';
import AdminDashboard from './components/AdminDashboard.vue';

// Simple navigation guard - just check if user is logged in
const requireAuth = (to, from, next) => {
  const auth = getAuth();
  if (auth.currentUser) {
    next();
  } else {
    next('/admin/login');
  }
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    beforeEnter: requireAuth
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router; 